import "@/legacy/artikelauswahl";
import "@/legacy/cad";
import "@/legacy/tabellenfilter";

import "@/ui/normblatt/lagerVerfuegbarkeit";
import "@/ui/normblatt/stepDownload";
import "@/ui/normblatt/tableColumns";
import "@/ui/zusatzinformationen/imageLayout";

import "scss/ui/normblatt/3dkonfigurator.scss";
import "scss/ui/normblatt/informationsbloecke.scss";

if ($("#form-product-recommend").length > 0) {
	import("@/ui/normblatt/produktEmpfehlen");
}
